import { Component, Input } from '@angular/core';
import { TableElementComponent } from '@uranda/ui';
import { ImageItem } from '../image-list-modal/image-list-modal.component';

@Component({
  selector: 'app-enhanced-image-icon',
  templateUrl: './enhanced-image-icon.component.html',
  styleUrls: ['./enhanced-image-icon.component.css'],
  standalone: false
})
export class EnhancedImageIconComponent extends TableElementComponent {
  imageType: any;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  override ngOnInit(): void {
    super.ngOnInit();
  }

  get hasImages(): boolean {
    return this.getImageCount() > 0;
  }

  /**
   * True when the backend masked this row's health data for lack of the "View patient health
   * data" permission (`healthDataRestricted` on the quote request / quote). Distinct from "no
   * images available": a restricted row renders a lock tile instead of the generic empty state,
   * with no click-through, since there is nothing to preview regardless of permission.
   */
  get restricted(): boolean {
    return this.getData()?.healthDataRestricted === true;
  }

  getImageCount(): number {
    return 0;
  }

  getPreviewImages(): string[] {
    return [];
  }

  getDisplayImages(): string[] {
    const previewImages = this.getPreviewImages();
    return previewImages.slice(0, 3);
  }

  getRemainingCount(): number {
    const totalImages = this.getPreviewImages().length;
    return Math.max(0, totalImages - 3);
  }

  getTooltip(): string {
    if (this.restricted) {
      return 'Restricted';
    }
    if (!this.hasImages) {
      return `No ${this.imageType} images available`;
    }
    const count = this.getImageCount();
    const type = this.getImageType();
    return `View ${count} ${type} image${count > 1 ? 's' : ''}`;
  }

  getImageAltText(index: number): string {
    const type = this.getImageType().toLowerCase();

    if (type.includes('pdf')) {
      return this.getImageType();
    }

    return `${this.getImageType()} ${index + 1}`;
  }

  getImageType(): string {
    return '';
  }

  getNoContentIcon(): string {
    const type = this.getImageType().toLowerCase();
    if (type.includes('pdf')) {
      return 'file-type-pdf';
    }
    return 'photo-off';
  }

  getNoContentText(): string {
    const type = this.getImageType().toLowerCase();
    if (type.includes('pdf')) {
      return 'No PDF';
    }
    return 'No attachments';
  }

  getData(): any {
    return this.data;
  }

  onImageClick(event: Event, i: number): void {
    event.stopPropagation();

    if (!this.hasImages) {
      return;
    }
    this.open(i);
  }

  getImageItems(): ImageItem[] {
    return [];
  }

  openImageViewer(index: number, images: ImageItem[]): void {
  }

  async open(index: number): Promise<void> { }
}